import ArticleRoundedIcon from "@mui/icons-material/ArticleRounded";

export const article = (props) => {
  return <ArticleRoundedIcon {...props} />;
};
